import { render, staticRenderFns } from "./PlanComponent.vue?vue&type=template&id=32c75f1d"
import script from "./PlanComponent.vue?vue&type=script&lang=js"
export * from "./PlanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports